import { render } from "./RecordPanel.vue?vue&type=template&id=76d6c9bb"
import script from "./RecordPanel.vue?vue&type=script&lang=js"
export * from "./RecordPanel.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__